import React from 'react';
import { Container, Col, Row, ListGroup, Button, Modal, Image, Badge, InputGroup, Form, Dropdown, DropdownButton } from 'react-bootstrap';
import { FaEye, FaRedo } from 'react-icons/fa';

import { VoteStars } from "./voteStars";

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class RandomMoviePage extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            randomMovie: null,

            includeMovies: "Unwatched",
            
            user: null,
            users: [],
            movies: [],
            movieUserVotes: {},

            showAnimatedPlaceholder: false,
            
            showErrorModal: false,
            errorModalText: ""
        };
        
        this.refreshData();
    }

    async refreshData() {
        const u = await IntrashBackend.getLoggedInUser();
        const allUsers = await IntrashBackend.getUsers();
        const allMovies = await IntrashBackend.getMovies();
        const allVotes = await IntrashBackend.getMovieUserVotes();
        this.setState({ movies: allMovies, user: u, users: allUsers, movieUserVotes: allVotes });
    }

    resetPage() {
        this.setState({
            randomMovie: null,
            showAnimatedPlaceholder: false,
            showErrorModal: false
        });
    }

    movieAverageVote(movieId) {
        if (this.state.movieUserVotes[movieId] === undefined) return null;
        var voteCount = 0;
        var totalVote = 0.0;
        Object.values(this.state.movieUserVotes[movieId]).forEach(v => { totalVote += v; ++voteCount; });
        return voteCount > 0 ? (totalVote / voteCount) : null;
    }

    movieAverageVoteString(movieId) {
        const averageVote = this.movieAverageVote(movieId);
        return averageVote === null ? "-" : (averageVote / 20.0).toFixed(2);
    }

    movieUserVote(movieId, userId) {
        if (this.state.movieUserVotes[movieId] === undefined) return null;
        if (this.state.movieUserVotes[movieId][userId] === undefined) return null;
        return this.state.movieUserVotes[movieId][userId];
    }

    movieUserVoteString(movieId, userId) {
        const vote = this.movieUserVote(movieId, userId);
        return vote === null ? "-" : (vote / 20.0);
    }

    pickRandomMovie() {
        var pickableMovies;
        if (this.state.includeMovies === "Watched") {
            pickableMovies = []
            this.state.movies.forEach(m => { if (m.watched) { pickableMovies.push(m); } });
        }
        else if (this.state.includeMovies === "Unwatched") {
            pickableMovies = []
            this.state.movies.forEach(m => { if (!m.watched) { pickableMovies.push(m); } });
        }
        else {
            pickableMovies = this.state.movies;
        }
        const randomIndex = Math.floor(Math.random() * pickableMovies.length) % pickableMovies.length;
        this.setState({ randomMovie: pickableMovies[randomIndex] });
    }

    handlePlaceholderClicked(e) {
        this.setState({ showAnimatedPlaceholder: true });
        setTimeout(() => this.pickRandomMovie(), 1520);
        e.preventDefault();
    }

    getRandomText() {
        const randomTexts = [
            "the girls will wake up... when they are hungry",
            "do you like watermelons?",
            "click me... if you dare",
            "you cannot control me",
            "feel that entropy",
            "bananas? bananas!",
            "I'm sorry, Sweet",
            "CLICK ME",
            "MIAO",
            "MEOW",
            "mIaO",
            "MiAo",
            "mEoW",
            "MeOw"
        ];
        const randomTextIndex = Math.floor(Math.random() * randomTexts.length) % randomTexts.length;
        return randomTexts[randomTextIndex];
    }

    renderPlaceholder() {
        const renderImage = () => {
            if (this.state.showAnimatedPlaceholder) {
                return (<Image rounded src="HausuCat_Animated.gif"/>);
            }
            else {
                return (<Image rounded src="HausuCat_Static.gif"/>);
            }
        }
        const randomText = this.getRandomText();
        return (
            <Container>
                <br/>
                <Row>
                    <Col/>
                    <Col xs="auto">
                        <h2 style={{ color: "crimson", fontStyle: "italic", fontWeight: "normal" }}>{randomText}</h2>
                    </Col>
                    <Col/>
                </Row>
                <br/>
                <Row>
                    <Col/>
                    <Col xs="auto" style={{ cursor: "pointer" }} onClick={(e) => this.handlePlaceholderClicked(e)}>
                        {renderImage()}
                    </Col>
                    <Col/>
                </Row>
                <br/>
                <Row>
                    <Col/>
                    <Col xs="auto">
                        <Form>
                            <InputGroup className="mb-2 mr-sm-2">
                                <InputGroup.Prepend><InputGroup.Text><FaEye/></InputGroup.Text></InputGroup.Prepend>
                                <DropdownButton as={InputGroup.Append} variant="outline-secondary" title={this.state.includeMovies} style={{ backgroundColor: "white" }}>
                                    <Dropdown.Item onSelect={() => { this.setState({ includeMovies: "All" }); }}>All</Dropdown.Item>
                                    <Dropdown.Item onSelect={() => { this.setState({ includeMovies: "Watched" }); }}>Watched</Dropdown.Item>
                                    <Dropdown.Item onSelect={() => { this.setState({ includeMovies: "Unwatched" }); }}>Unwatched</Dropdown.Item>
                                </DropdownButton>
                            </InputGroup>
                        </Form>
                    </Col>
                    <Col/>
                </Row>
            </Container>
        )
    }

    renderRandomMovie() {
        const movie = this.state.randomMovie;
        const averageVote = this.movieAverageVote(movie.id);

        const mapUserDetailsToMovieDetails = (userDetails) => {
            const u = userDetails.user;
            return (
                <ListGroup.Item className="list-group-item border-0" style={{ padding: "0", overflow: "hidden", backgroundColor: "transparent" }} key={u.id} onClick={() => this.showReview(movie, u.id)}>
                    <Row className="align-items-center">
                        <Col xs="auto" style={{ paddingRight: 0 }}>
                            <VoteStars starSize="1.25em" vote={userDetails.vote} canEditVote={false}/>
                        </Col>
                        <Col xs="auto" style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <Badge style={{ color: "darkslategray", fontWeight: "bold", fontSize: "1.5em" }}>{u.username}</Badge>
                        </Col>
                        <Col/>
                    </Row>
                </ListGroup.Item>
            );
        };
        const renderMovieDetails = () => {
            var userDetails = [];
            const userVotes = this.state.movieUserVotes[movie.id];
            this.state.users.forEach(u => {
                const uVote = userVotes[u.id];
                if (uVote !== undefined) {
                    userDetails.push({
                        user: u,
                        vote: uVote || 0
                    });
                }
            });
            userDetails.sort((a, b) => b.user.username.toUpperCase() < a.user.username.toUpperCase() ? 1 : -1);
            if (userDetails.length > 1) {
                var lUserDetails = [];
                var rUserDetails = [];
                for (var i = 0; i < userDetails.length; ++i) {
                    if ((i % 2) === 0) { lUserDetails.push(userDetails[i]); }
                    else { rUserDetails.push(userDetails[i]); }
                }
                return (
                    <Row>
                        <Col/>
                        <Col xs="auto">
                            <ListGroup variant="flush" style={{ paddingTop: "1em" }}>
                                {Object.values(lUserDetails).map(mapUserDetailsToMovieDetails)}
                            </ListGroup>
                        </Col>
                        <Col xs="auto">
                            <ListGroup variant="flush" style={{ paddingTop: "1em" }}>
                                {Object.values(rUserDetails).map(mapUserDetailsToMovieDetails)}
                            </ListGroup>
                        </Col>
                        <Col/>
                    </Row>
                );
            }
            else {
                return (
                    <Row>
                        <Col/>
                        <Col xs="auto">
                            <ListGroup variant="flush" style={{ paddingTop: "1em" }}>
                                {Object.values(userDetails).map(mapUserDetailsToMovieDetails)}
                            </ListGroup>
                        </Col>
                        <Col/>
                    </Row>
                );
            }
        };

        return (
            <Container fluid>
                <br/>
                <Row>
                    <Col/>
                    <Col xs="auto">
                        <h1 style={{ fontWeight: "bolder", fontSize: "3em" }}>{movie.title}</h1>
                    </Col>
                    <Col/>
                </Row>
                <Row>
                    <Col/>
                    <Col xs="auto">
                        <h1 style={{ fontWeight: "bold", color: "darkslategray", fontSize: "2em" }}>{movie.releaseYear}</h1>
                    </Col>
                    <Col/>
                </Row>
                <br/>
                <Row>
                    <Col/>
                    <Col xs="auto">
                        <VoteStars starSize="3.5em" vote={averageVote || 0} canEditVote={false}/>
                    </Col>
                    <Col/>
                </Row>
                <Row>
                    <Col/>
                    <Col xs="auto">
                        <h3 style={{ "color": "darkslategray" }}>{this.movieAverageVoteString(movie.id)}</h3>
                    </Col>
                    <Col/>
                </Row>
                <br/>
                {renderMovieDetails()}
                <br/>
                <Row>
                    <Col/>
                    <Col xs="auto">
                        <FaRedo size="1.5em" cursor="pointer" onClick={() => this.resetPage()}/>
                    </Col>
                    <Col/>
                </Row>
            </Container>
        );
    }

    renderContent() {
        if (this.state.randomMovie === null) {
            return this.renderPlaceholder();
        }
        else {
            return this.renderRandomMovie();
        }
    }

    render() {
        return (
            <>
                <Container fluid>
                    <br/>
                    {this.renderContent()}
                </Container>
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}